/* ==========================================================================
  Sliding-fill CTA hover — enhancement pass
  Companion to cta-slide.css. Adds the `cta-slide` class to the cucumber
  landing page's primary CTAs and builds the two-copy label markup the roll
  needs, matching assets/barbie-landing.js. Doing it here rather than in the
  templates means the shared add-to-cart-button snippet is untouched.

  Idempotent: every element it has already processed is marked with
  data-cta-slide="1" and skipped, so re-running after a cart re-render is safe.
  ========================================================================== */
(function () {
  'use strict';

  /* Six sections each load this file so they stay self-sufficient when dropped
     on another page. A <script> with a repeated src is fetched once but
     *executed* once per tag, which would leave six MutationObservers on the
     document. One is enough. */
  if (window.__ctaSlideInit) return;
  window.__ctaSlideInit = true;

  /* The primary CTAs of the sections on page.cucumber-lp.json. Quantity
     steppers (.jpm-qty__btn, .jugc-buy__qty-btn) and the gallery arrow
     (.jpm__gallery-next) are intentionally absent — a rolling label on a "+"
     is noise, not polish. */
  var CTA_SELECTOR = [
    '.hero-banner__button',
    '.nipg-card__atc',
    '.jpm__cta',
    '.jpm__add',
    '.jpm__pair-add',
    '.psp__atc',
    '.jugc-buy__add',
    '.cyr-card__atc'
  ].join(',');

  /* Find the element whose text should roll. The six add-to-cart CTAs render
     through snippets/add-to-cart-button.liquid, which nests the label as
     `.add-to-cart-text__content > span > span` alongside a plus icon; rolling
     the whole button there would drag the icon along. Everything else holds
     its label as direct text. */
  function labelHost(btn) {
    var nested = btn.querySelector('.add-to-cart-text__content span span');
    if (nested) return nested;

    var content = btn.querySelector('.add-to-cart-text__content');
    if (content) return content;

    /* Only safe if the button's own children are all text — otherwise we would
       be about to throw away an icon or a nested component. */
    for (var i = 0; i < btn.childNodes.length; i++) {
      if (btn.childNodes[i].nodeType === 1) return null;
    }
    return btn;
  }

  function buildTrack(text) {
    var label = document.createElement('span');
    label.className = 'cta-slide__label';

    var track = document.createElement('span');
    track.className = 'cta-slide__track';

    var first = document.createElement('span');
    first.textContent = text;

    /* The duplicate is decorative — hiding it keeps screen readers and
       in-page find from seeing the label twice. */
    var second = document.createElement('span');
    second.textContent = text;
    second.setAttribute('aria-hidden', 'true');

    track.appendChild(first);
    track.appendChild(second);
    label.appendChild(track);
    return label;
  }

  function enhance(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll(CTA_SELECTOR);

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.dataset.ctaSlide === '1') continue;
      btn.dataset.ctaSlide = '1';

      /* The fill is pure CSS, so it works even when there is no label we can
         safely wrap. Add the class regardless. */
      btn.classList.add('cta-slide');

      var host = labelHost(btn);
      if (!host) continue;

      var text = host.textContent.trim();
      if (!text) continue;

      /* Some of these CTAs are icon-only by design — .jpm__pair-add hides its
         label with `display: none` and shows just a plus. There is nothing to
         roll, so leave the markup alone; the fill above still applies. */
      if (!host.getClientRects().length) continue;

      host.textContent = '';
      host.appendChild(buildTrack(text));
    }
  }

  function init() {
    enhance(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* These CTAs are re-rendered by the theme: adding to cart swaps the buy
     buttons via Section Rendering, the UGC and pairs cards re-render on
     variant change, and the theme editor replaces whole sections. Rather than
     guess at every event name, watch the document and re-enhance whatever
     appears. Debounced through rAF so a burst of mutations costs one pass, and
     the data-attribute guard keeps it to newly added nodes. */
  if (typeof MutationObserver === 'function') {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        enhance(document);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function (e) {
    enhance(e.target);
  });
})();
